import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';

class Flatpickr {
  constructor() {
    this._init();
  }
  _init() {
    document.addEventListener('DOMContentLoaded', function () {
      flatpickr.localize(French);
      // On active le calendrier sur notre champ
      flatpickr('.datepicker-custom', {
        altInput: true, // Affiche la date en format lisible (ex: 20 Octobre 2025)
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d' // Date envoyée au serveur (ex: 2025-10-20)
      });
    });
  }
}
export const flatpickrInstance = new Flatpickr();
